var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32Download(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C16.5523 1 17 1.44772 17 2V17.7352L20.8278 14.2597C21.2367 13.8884 21.8691 13.9189 22.2403 14.3278C22.6116 14.7367 22.5811 15.3691 22.1722 15.7403L16.7395 20.6732C16.5566 20.874 16.293 21 16 21L15.9966 21C15.7547 21.0008 15.5125 20.9142 15.321 20.7403L9.82771 15.7515C9.41886 15.3802 9.38842 14.7478 9.75972 14.3389C10.131 13.9301 10.7634 13.8997 11.1723 14.271L15 17.7471V2C15 1.44772 15.4477 1 16 1ZM7.01653 6.4668C6.49813 6.4668 6 6.92084 6 7.57841V25.3542C6 26.0131 6.49843 26.4668 7.01653 26.4668H24.9844C25.5013 26.4668 26 26.0134 26 25.3542V7.57841C26 6.92053 25.5016 6.4668 24.9844 6.4668H22.0004C21.4481 6.4668 21.0004 6.01908 21.0004 5.4668C21.0004 4.91452 21.4481 4.4668 22.0004 4.4668H24.9844C26.6928 4.4668 28 5.90468 28 7.57841V25.3542C28 27.0286 26.6931 28.4668 24.9844 28.4668H7.01653C5.30717 28.4668 4 27.0289 4 25.3542V7.57841C4 5.90437 5.30747 4.4668 7.01653 4.4668H10.0006C10.5528 4.4668 11.0006 4.91452 11.0006 5.4668C11.0006 6.01908 10.5528 6.4668 10.0006 6.4668H7.01653Z",
    fill: "#0A7E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Download);
export default __webpack_public_path__ + "static/media/icon32_download.13c29d877677d5b33e1857113e18a16e.svg";
export { ForwardRef as ReactComponent };